import { FeatureSpotlightKicker } from '@/components/marketing/feature-spotlight'
import { MarketingLead } from '@/components/marketing/marketing-lead'
import { MarketingSectionTitle } from '@/components/marketing/marketing-section-title'
import { cn } from '@/lib/utils'

/** Shared kicker + section title + lead stack (Meet Ivy spotlights + feature page sections). */
export function MarketingSectionCopy({
  kicker,
  title,
  lead,
  align = 'left',
  className,
  children,
}: {
  kicker?: string
  title: string
  lead?: string
  align?: 'left' | 'center'
  className?: string
  children?: React.ReactNode
}) {
  return (
    <div
      className={cn(
        'marketing-section-copy',
        align === 'center' && 'marketing-section-copy--center',
        className
      )}
    >
      {kicker ? <FeatureSpotlightKicker>{kicker}</FeatureSpotlightKicker> : null}
      <MarketingSectionTitle>{title}</MarketingSectionTitle>
      {lead ? (
        <MarketingLead className={align === 'center' ? 'marketing-lead--center' : undefined}>
          {lead}
        </MarketingLead>
      ) : null}
      {children}
    </div>
  )
}
